import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import contactNoteDialogService from 'services/contactNoteDialogService';
import { PartnerDetailType } from 'types/LegalPartner';

export const useGetPartnerDetails = (id: string, usedInBr: boolean) => {
  return useQuery<PartnerDetailType, AxiosError>({
    queryKey: ['useGetPartnerDetails', id],
    queryFn: () => contactNoteDialogService.getPartnerDetails(id),
    enabled: !usedInBr && !!id,
  });
};
